import { Modal, Button, Form } from "react-bootstrap";

const ModalComponent = ({ show, handleClose, title, fields, handleInputChange, handleSubmit, formData }) => {
    return (
        <Modal show={show} onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmit}>
                    {fields.map((field, index) => (
                        <Form.Group key={index} className="mt-3">
                            <Form.Label>{field.label}</Form.Label>

                            {field.type === "select" ? (
                                <Form.Select
                                    name={field.name}
                                    value={formData[field.name] || ""}
                                    onChange={handleInputChange}
                                    required={field.required}
                                >
                                    <option value="">{field.placeholder}</option>
                                    {field.options.map((option) => (
                                        <option key={option.value} value={option.value}>
                                            {option.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            ) : field.type === "file" ? (
                                <Form.Control
                                    type="file"
                                    name={field.name}
                                    onChange={field.onChange}
                                    accept={field.accept || "image/*"}
                                    required={field.required}
                                />
                            ) : (
                                <Form.Control
                                    type={field.type}
                                    placeholder={field.placeholder}
                                    name={field.name}
                                    value={formData[field.name] || ""}
                                    onChange={handleInputChange}
                                    required={field.required}
                                />
                            )}
                        </Form.Group>
                    ))}
                    <Button type="submit" className="mt-3">
                        {title}
                    </Button>
                </Form>
            </Modal.Body>
        </Modal>
    );
};

export default ModalComponent;

